(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7c47"];
var parcelRegister = parcelRequire.register;
parcelRegister("hWDYh", function(module, exports) {

$parcel$export(module.exports, "tabsGroup", function () { return $035f141028b5bb9d$export$b1c9aa700a250758; });
const $035f141028b5bb9d$export$b1c9aa700a250758 = document.querySelectorAll(".js-tabs");
$035f141028b5bb9d$export$b1c9aa700a250758.forEach((tabGroup)=>{
    const tabItems = tabGroup.querySelectorAll(".js-tabs__tab-item");
    const panels = tabGroup.querySelectorAll(".js-tabs__panel");
    const closeAllPanels = ()=>panels.forEach((content)=>content.classList.remove("--active"));
    const resetAllTabItems = ()=>tabItems.forEach((link)=>link.classList.remove("--active"));
    tabItems.forEach((tabItem)=>{
        tabItem.addEventListener("click", (event)=>{
            event.preventDefault();
            if (tabItem.classList.contains("--active")) return;
            const targetId = tabItem.getAttribute("data-tab-target") ?? "";
            const targetPanel = tabGroup.querySelector(`[data-panel-id="${targetId}"]`);
            if (targetPanel === null) return;
            closeAllPanels();
            resetAllTabItems();
            targetPanel.classList.add("--active");
            tabItem.classList.add("--active");
            if (tabItem.classList.contains("js-leaflets-tab") && tabItem.classList.contains("--active")) targetPanel.dispatchEvent(new Event("initLeafletsGroup"));
        });
    });
});

});

})();
//# sourceMappingURL=tabs.c2134b09.js.map
